import 'angular-ui-bootstrap/src/buttons/buttons';
import 'angular-ui-bootstrap/src/collapse/collapse';
import 'angular-ui-bootstrap/src/dateparser/dateparser';
import 'angular-ui-bootstrap/src/datepicker/datepicker';
import 'angular-ui-bootstrap/src/debounce/debounce';
import 'angular-ui-bootstrap/src/dropdown/dropdown';
import 'angular-ui-bootstrap/src/isClass/isClass';
import 'angular-ui-bootstrap/src/modal/modal';
import 'angular-ui-bootstrap/src/multiMap/multiMap';
import 'angular-ui-bootstrap/src/popover/popover';
import 'angular-ui-bootstrap/src/position/position';
import 'angular-ui-bootstrap/src/progressbar/progressbar';
import 'angular-ui-bootstrap/src/stackedMap/stackedMap';
import 'angular-ui-bootstrap/src/tabs/tabs';
import 'angular-ui-bootstrap/src/tooltip/tooltip';
import 'angular-ui-bootstrap/src/typeahead/typeahead';

import 'angular-ui-bootstrap/template/datepicker/datepicker.html';
import 'angular-ui-bootstrap/template/datepicker/day.html';
import 'angular-ui-bootstrap/template/datepicker/month.html';
import 'angular-ui-bootstrap/template/datepicker/year.html';
import 'angular-ui-bootstrap/template/modal/window.html';
import 'angular-ui-bootstrap/template/modal/backdrop.html';
import 'angular-ui-bootstrap/template/popover/popover.html';
import 'angular-ui-bootstrap/template/popover/popover-html.html';
import 'angular-ui-bootstrap/template/popover/popover-template.html';
import 'angular-ui-bootstrap/template/progressbar/bar.html';
import 'angular-ui-bootstrap/template/progressbar/progress.html';
import 'angular-ui-bootstrap/template/progressbar/progressbar.html';
import 'angular-ui-bootstrap/template/tabs/tab.html';
import 'angular-ui-bootstrap/template/tabs/tabset.html';
import 'angular-ui-bootstrap/template/tooltip/tooltip-html-popup.html';
import 'angular-ui-bootstrap/template/tooltip/tooltip-popup.html';
import 'angular-ui-bootstrap/template/tooltip/tooltip-template-popup.html';
import 'angular-ui-bootstrap/template/typeahead/typeahead-match.html';
import 'angular-ui-bootstrap/template/typeahead/typeahead-popup.html';

export default [
  'ui.bootstrap.dateparser',
  'ui.bootstrap.buttons',
  'ui.bootstrap.collapse',
  'ui.bootstrap.dropdown',
  'ui.bootstrap.modal',
  'ui.bootstrap.popover',
  'ui.bootstrap.progressbar',
  'ui.bootstrap.tabs',
  'ui.bootstrap.tooltip',
  'ui.bootstrap.typeahead',
  'ui.bootstrap.datepicker',
];
